import React from 'react'

import LanguagesNav from '../../../../components/languagesNav'
import Form from '../../videos/form/form'

export const VideoForm = ({ ...props }) => {
  return (
    <LanguagesNav useAdditionalLanguages {...props} defaultValue={{ isPrivate: 1 }}>
      {({ dir }) => <Form isEdit={props.isEdit} dir={dir} isPremium={true} />}
    </LanguagesNav>
  )
}

export default VideoForm
